module.exports = __webpack_public_path__ + "img/document.585c7cec.svg";